import React from 'react';
import styleCom from "./REGCOM.module.scss";

import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import RadioGroup from "../../components/Radio/RadioGroup";
import {dateToYMD, ymdToDate} from "./REGComUtil";
import DatePicker from "../../components/DatePicker/DatePicker";
import TextArea from "../../components/TextArea/TextArea";


const RenderHtml = (props) => {

    let fu6mHtml=<></>;
    const radioOptions = [
        {mapCd: "presetYn", value: "0", label: "No"}
        ,{mapCd: "presetYn", value: "1", label: "Yes"}
    ];

    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }


    /* Event ****************************************************************************** */



    /* ****************************************************************************** Event */

    fu6mHtml =
      <>

          <div className={styleCom.title_wrap}>
              <h3>FU 1M</h3>
          </div>
          <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
              <Table variant='default' rowCnt={1} colSize={['20%', '80%']} rowSize={'56px'}>
                  <div>방문일자</div>
                  <div className={"col_merge"}>
                      <DatePicker selDate={ymdToDate(props.getFu6mVal('f6VisitDt'))}
                                  dateFormat={'yyyy-MM-dd'}
                                  onChange={(date) => props.setFu6mVal('f6VisitDt', dateToYMD(date))}/>
                  </div>
              </Table>
          </div>
          <div className={styleCom.title_wrap}>
              <h3>Vital Signs</h3>
          </div>
          <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
              <Table variant='default' rowCnt={4} colSize={['20%', '30%', '20%', '30%']} rowSize={'56px'}>
                  <div>첫번째 진료실 - 수축기 혈압</div>
                  <div style={{height: "56px"}}>
                      <InputUnitText type={"number"} unit={"mmHg"} isInteger maxLength={3}
                                     value={props.getFu6mVal('f6OSys1')}
                                     onChange={(value) => props.setFu6mVal('f6OSys1', value)}/>
                  </div>
                  <div>첫번째 진료실 - 이완기 혈압</div>
                  <div style={{height: "56px"}}>
                      <InputUnitText type={"number"} unit={"mmHg"} isInteger maxLength={3}
                                     value={props.getFu6mVal('f6ODia1')}
                                     onChange={(value) => props.setFu6mVal('f6ODia1', value)}/>
                  </div>
                  <div>첫번째 진료실 - 맥박수</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} isInteger maxLength={3}
                                     value={props.getFu6mVal('f6OPr1')}
                                     onChange={(value) => props.setFu6mVal('f6OPr1', value)}/>
                  </div>
                  <div>두번째 진료실 - 수축기 혈압</div>
                  <div style={{height: "56px"}}>
                      <InputUnitText type={"number"} unit={"mmHg"} isInteger maxLength={3}
                                     value={props.getFu6mVal('f6OSys2')}
                                     onChange={(value) => props.setFu6mVal('f6OSys2', value)}/>
                  </div>
                  <div>두번째 진료실 - 이완기 혈압</div>
                  <div style={{height: "56px"}}>
                      <InputUnitText type={"number"} unit={"mmHg"}  isInteger maxLength={3}
                                     value={props.getFu6mVal('f6ODia2')}
                                     onChange={(value) => props.setFu6mVal('f6ODia2', value)}/>
                  </div>
                  <div>두번째 진료실 - 맥박수</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"}  isInteger maxLength={3}
                                     value={props.getFu6mVal('f6OPr2')}
                                     onChange={(value) => props.setFu6mVal('f6OPr2', value)}/>
                  </div>
              </Table>
          </div>
          <div className={styleCom.title_wrap}>
              <h3>Medication</h3>
          </div>
          <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
              <Table variant='default' rowCnt={16} colSize={['20%', '30%', '20%', '30%']} rowSize={'56px'}>
                  <div>ACEi 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')} selectedValue={props.getFu6mVal('f6AceiYn')}
                                  onChange={(val) => props.setFu6mVal('f6AceiYn', val)}/>
                  </div>
                  <div>ACEi 성분명</div>
                  <div>
                      <InputUnitText type={"String"} value={props.getFu6mVal('f6AceiName')} maxLength={50}
                                     onChange={(value) => props.setFu6mVal('f6AceiName', value)}/>
                  </div>
                  <div>ACEi 용량</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6AceiDose')}
                                     onChange={(value) => props.setFu6mVal('f6AceiDose', value)}/>
                  </div>
                  <div>ARB 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')} selectedValue={props.getFu6mVal('f6ArbYn')}
                                  onChange={(val) => props.setFu6mVal('f6ArbYn', val)}/>
                  </div>
                  <div>ARB 성분명</div>
                  <div>
                      <InputUnitText type={"String"} value={props.getFu6mVal('f6ArbName')} maxLength={50}
                                     onChange={(value) => props.setFu6mVal('f6ArbName', value)}/>
                  </div>
                  <div>ARB 용량</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6ArbDose')}
                                     onChange={(value) => props.setFu6mVal('f6ArbDose', value)}/>
                  </div>
                  <div>Entresto 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6EntrestoYn')}
                                  onChange={(val) => props.setFu6mVal('f6EntrestoYn', val)}/>
                  </div>
                  <div>Entresto 용량</div>
                  <div>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6EntrestoDose')}
                                     onChange={(value) => props.setFu6mVal('f6EntrestoDose', value)}/>
                  </div>
                  <div>베타차단제 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6BbYn')}
                                  onChange={(val) => props.setFu6mVal('f6BbYn', val)}/>
                  </div>
                  <div>베타차단제 성분명</div>
                  <div>
                      <InputUnitText type={"String"} value={props.getFu6mVal('f6BbName')} maxLength={50}
                                     onChange={(value) => props.setFu6mVal('f6BbName', value)}/>
                  </div>
                  <div>베타차단제 용량</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6BbDose')}
                                     onChange={(value) => props.setFu6mVal('f6BbDose', value)}/>
                  </div>
                  <div>칼슘통로차단제 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6CcbYn')}
                                  onChange={(val) => props.setFu6mVal('f6CcbYn', val)}/>
                  </div>
                  <div>칼슘통로차단제 성분명</div>
                  <div>
                      <InputUnitText type={"String"} value={props.getFu6mVal('f6CcbName')} maxLength={50}
                                     onChange={(value) => props.setFu6mVal('f6CcbName', value)}/>
                  </div>
                  <div>칼슘통로차단제 용량</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6CcbDose')}
                                     onChange={(value) => props.setFu6mVal('f6CcbDose', value)}/>
                  </div>
                  <div>이뇨제 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6DiureticsYn')}
                                  onChange={(val) => props.setFu6mVal('f6DiureticsYn', val)}/>
                  </div>
                  <div>이뇨제 성분명</div>
                  <div>
                      <InputUnitText type={"String"} value={props.getFu6mVal('f6DiureticsName')} maxLength={50}
                                     onChange={(value) => props.setFu6mVal('f6DiureticsName', value)}/>
                  </div>
                  <div>이뇨제 용량</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6DiureticsDose')}
                                     onChange={(value) => props.setFu6mVal('f6DiureticsDose', value)}/>
                  </div>
                  <div>SGLT2 처방 여부</div>
                  <div>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6Sglt2iYn')}
                                  onChange={(val) => props.setFu6mVal('f6Sglt2iYn', val)}/>
                  </div>
                  <div>SGLT2 성분명</div>
                  <div>
                      <InputUnitText type={"String"} value={props.getFu6mVal('f6Sglt2iName')} maxLength={50}
                                     onChange={(value) => props.setFu6mVal('f6Sglt2iName', value)}/>
                  </div>
                  <div>SGLT2 용량</div>
                  <div className={"col_merge"}>
                      <InputUnitText type={"number"} unit={"mg"} value={props.getFu6mVal('f6Sglt2iDose')}
                                     onChange={(value) => props.setFu6mVal('f6Sglt2iDose', value)}/>
                  </div>
                  <div>스타틴 혹은 에제티미브 처방여부</div>
                  <div className={"col_merge"}>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6LlaYn')}
                                  onChange={(val) => props.setFu6mVal('f6LlaYn', val)}/>
                  </div>
                  <div>경구 혈당 강하제 처방여부</div>
                  <div className={"col_merge"}>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6OhaYn')}
                                  onChange={(val) => props.setFu6mVal('f6OhaYn', val)}/>
                  </div>
                  <div>인슐린 처방여부</div>
                  <div className={"col_merge"}>
                      <RadioGroup options={getOptionList('presetYn')}
                                  selectedValue={props.getFu6mVal('f6InsulinYn')}
                                  onChange={(val) => props.setFu6mVal('f6InsulinYn', val)}/>
                  </div>
              </Table>
          </div>
          <div className={styleCom.main_wrap} style={{marginTop: "10px", marginBottom: "10px", padding: "20px"}}>
              <Table variant='default' rowCnt={1} colSize={['20%', '80%']} rowSize={'56px'}>
                  <div>기타 / side effect</div>
                  <div>
                      <TextArea width={"800px"} maxLength={1000}
                                value={props.getFu6mVal('f6Comment')}
                                onChange={(val) => props.setFu6mVal('f6Comment', val)}
                                margin={"10px 0 2px auto"}/>
                  </div>
              </Table>
          </div>

      </>;


    let renderHtml =
      <></>
    ;

    if (props.contentId === "T_FU_6M") {
        renderHtml = fu6mHtml;

    } else {
        renderHtml = <h3>...</h3>;
    }
    return (
      <>
          {renderHtml}
      </>
    );

};

export default RenderHtml;

